var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './AddActionView.html';
import { translate } from 'angular';
import { AddAction, } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/addAction/addAction.dispatcher';
import { ActionViewModel } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/viewModels/ActionViewModel';
import { ActionFeatures } from '../../../actions/ActionFeatures';
import './addAction.scss';
let AddActionComponent = class AddActionComponent {
    static $inject = ['$translate'];
    //#endregion
    $onInit() {
        this.checkFeatures();
    }
    async checkFeatures() {
        this.isProcessContentAssistantEnabled = await ActionFeatures.isActionProcessContentAssistantEnabled();
        this.isActionExecuteTemplateEnabled = await ActionFeatures.isActionExecuteTemplateEnabled();
        this.isActionExecuteScriptV2Enabled = await ActionFeatures.isActionExecuteScriptV2Enabled();
        this.isActionExecuteBlipFunctionEnabled = await ActionFeatures.isActionExecuteBlipFunction();
    }
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    onAddAction(type) {
        const action = new AddAction({
            action: new ActionViewModel({
                type,
                $title: this.getActionTypeTitle(type),
            }),
        });
        this.$dispatch(action);
    }
    getActionTypeTitle(type) {
        const toCamelCase = (value) => value.charAt(0).toLowerCase() + value.slice(1);
        const translateResource = `builder-tabs-actions.${toCamelCase(type.toString())}.title`;
        return this.$translate.instant(translateResource);
    }
    isActionProcessContentAssistantEnabled() {
        return this.isProcessContentAssistantEnabled;
    }
};
AddActionComponent.$inject = ['$translate'];
AddActionComponent = __decorate([
    Component({
        template,
        bindings: {
            state: '=',
            onAction: '&?',
            onOpenActionModal: '&?',
            addActionText: '@?',
            isDisabled: '<?',
            isSubflowApplication: '<?',
            isAiAgentState: '<?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _a : Object])
], AddActionComponent);
export { AddActionComponent };
